import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { fieldForceFetchDesignationList } from "../../../redux/actions/fieldForceAction";
import DesignationTableData from "./designationTableData";
import DownArrow from "../../../assets/filterArrowDown.svg";
import UpArrow from "../../../assets/filterArrowUp.svg";
import "../fieldForce.css";
import ErrorPopup from "../../../components/popups/ErrorPopup";
import LoadingSpinnerTable from "../../../components/utilites/loader";
import { useNavigate } from "react-router-dom";
import NumberPagination from "../../../components/Pagination/number-pagination";

const FieldForceDesTable = ({ search, page_no, filterData }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const componentRef = useRef(null);
  const [page, setPage] = useState(page_no ? page_no : 1);
  const [fildForceDesignationData, setFieldForceDesignationData] = useState([]);
  const [openOrder, setOpenOrder] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);
  const [approval_limit_from, setOrder_approval_limit_from] = useState(
    filterData?.approval_limit_from ?? null
  );
  const [approval_limit_to, setOrder_approval_limit_to] = useState(
    filterData?.approval_limit_to ?? null
  );

  useEffect(() => {
    if (filterData?.approval_limit_from) {
      setOrder_approval_limit_from(filterData?.approval_limit_from);
    } else {
      setOrder_approval_limit_from(null);
    }
    if (filterData?.approval_limit_to) {
      setOrder_approval_limit_to(filterData?.approval_limit_to);
    } else {
      setOrder_approval_limit_to(null);
    }
  }, [filterData]);

  const fetchFieldForceDesignationList = () => {
    dispatch(
      fieldForceFetchDesignationList(
        {
          order_approval_limit_from: filterData?.approval_limit_from,
          order_approval_limit_to: filterData?.approval_limit_to,
          search,
          page,
        },
        onSuccess,
        onError
      )
    );
    setOpenOrder(false);
  };

  const ApllyFilter = () => {
    navigate(
      `/field-force/designation?page=1${
        search ? `&search=${search}` : ""
      }&approval_limit_from=${
        approval_limit_from ?? ""
      }&approval_limit_to=${approval_limit_to}`
    );
  };

  useEffect(() => {
    if (page_no) {
      setPage(page_no);
    }
  }, [page_no]);

  useEffect(() => {
    setLoading(true);
    fetchFieldForceDesignationList();
  }, [page, search, filterData, dispatch]);

  const onSuccess = (data) => {
    setLoading(false);
    setFieldForceDesignationData(data.data.data);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    setLoading(false);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  const orderApprovalLimitClear = () => {
    setOrder_approval_limit_from(null);
    setOrder_approval_limit_to(null);
    setOpenOrder(false);
  };

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setOpenOrder(false);
    }
  };

  useEffect(() => {
    if (openOrder) {
      document.addEventListener("click", handleClickOutside);
    } else {
      document.removeEventListener("click", handleClickOutside);
    }
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [openOrder]);

  const queryParams = [];
  if (search) queryParams.push(`search=${search}`);
  if (filterData?.approval_limit_from)
    queryParams.push(`approval_limit_from=${filterData?.approval_limit_from}`);
  if (filterData?.approval_limit_to)
    queryParams.push(`approval_limit_to=${filterData?.approval_limit_to}`);

  const queryString = queryParams.length > 0 ? `&${queryParams.join("&")}` : "";

  return (
    <>
      <div>
        <div className="table-container">
          <table className="main-table">
            <thead>
              <tr className="table-rows text-nowrap">
                <th className="table-heads " width={"4%"}>
                  #
                </th>
                <th className="table-heads" width={"14%"}>
                  Designation ID
                </th>
                <th className="table-heads" width={"18%"}>
                  Designation Name
                </th>
                <th ref={componentRef} className="table-heads" width={"15%"}>
                  <span
                    onClick={() => {
                      setOpenOrder(!openOrder);
                    }}
                    className={
                      openOrder
                        ? "Medium_Purple cursor_pointer"
                        : "cursor_pointer"
                    }
                  >
                    {" "}
                    <span
                      className={
                        filterData?.approval_limit_from &&
                        filterData?.approval_limit_to
                          ? "Medium_Purple fw_700"
                          : ""
                      }
                    >
                      Order Approval Limit
                    </span>
                    {openOrder ? (
                      <img src={UpArrow} className="mb-1 mx-1" alt="v" />
                    ) : (
                      <img src={DownArrow} className=" mx-1" alt="v" />
                    )}
                  </span>
                  {openOrder && (
                    <div className=" position-relative">
                      <div className=" position-absolute order-container">
                        <div className=" d-flex my-3">
                          <div className="mx-3">
                            <label className="fn_Nunito color_262c3d ">
                              From
                            </label>
                            <div className=" d-flex mt-1 ">
                              <div className=" d-flex align-items-center  py-1 px-3 amount_input_container w-100">
                                <span className="fn_Nunito fs_14 fw_700 Medium_Purple ">
                                  ₹.
                                </span>
                                <input
                                  type="text"
                                  className="amount_input py-1 ms-1"
                                  placeholder="Enter amount"
                                  value={approval_limit_from ?? ""}
                                  onChange={(e) => {
                                    setOrder_approval_limit_from(
                                      e.target.value
                                    );
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                          <div className="me-3">
                            <label className="fn_Nunito color_262c3d ">
                              To
                            </label>
                            <div className=" d-flex mt-1">
                              <div className=" d-flex align-items-center  py-1 px-3 amount_input_container ">
                                <span className="fn_Nunito fs_14 fw_700 Medium_Purple ">
                                  ₹.
                                </span>
                                <input
                                  type="text"
                                  className="amount_input py-1 ms-1"
                                  placeholder="Enter amount"
                                  value={approval_limit_to ?? ""}
                                  onChange={(e) => {
                                    setOrder_approval_limit_to(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="mt-2">
                          <div className="d-flex justify-content-end mx-3 gap-3">
                            <button
                              className="filter-clear-btn px-3 py-1 fs_14"
                              onClick={() => {
                                orderApprovalLimitClear();
                                navigate(
                                  `/field-force/designation?page=1${
                                    search ? `&search=${search}` : ""
                                  }`
                                );
                              }}
                            >
                              clear
                            </button>
                            <button
                              className="filter-btn px-2 py-1 fs_14"
                              type="button"
                              onClick={() => {
                                ApllyFilter();
                              }}
                            >
                              Apply Filter
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </th>
                <th className="table-heads text-nowrap" width={"10%"}>
                  Approval level
                </th>
                <th className="table-heads-action" width={"15%"}>
                  Actions
                </th>
              </tr>
            </thead>
            <tbody style={{ position: "relative" }}>
              {loading === true ? (
                <tr className="list-spinner-container">
                  <LoadingSpinnerTable />
                </tr>
              ) : fildForceDesignationData?.designations?.length > 0 ? (
                <>
                  {fildForceDesignationData?.designations?.map(
                    (eachRow, index) => (
                      <DesignationTableData
                        key={index}
                        data={eachRow}
                        index={index}
                        currentPage={
                          fildForceDesignationData?.pagination?.currentPage
                        }
                        fetchFieldForceDesignationList={
                          fetchFieldForceDesignationList
                        }
                      />
                    )
                  )}
                </>
              ) : (
                <tr>
                  <td
                    colSpan="1"
                    className="text-center no-data-container fs_16"
                  >
                    <span>~ No Data Found ~</span>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className={loading === true ? `loading-event` : ""}>
          {fildForceDesignationData?.pagination?.totalPages > 0 && (
            <NumberPagination
              setCurrentPage={setPage}
              pagination={fildForceDesignationData?.pagination?.currentPage}
              totalPages={fildForceDesignationData?.pagination?.totalPages}
              path={"/field-force/designation"}
              filters={`${queryString}`}
            />
          )}
        </div>
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </div>
    </>
  );
};

export default FieldForceDesTable;
